import ContentShrink from './ContentShrink';

export default ContentShrink;
